<template>
	<div>
		<div class="projects-filters" v-if="count > 1 && !sample">
			<a class="button mod-filter" v-for="c in categories" @click.prevent="setActive(c.cat_ID)" :class="{ active : catID === c.cat_ID }" href="#">{{ c.name }}</a>
		</div>

		<div class="projects-f">
			<div class="project ani-projects-custom-all"
				 :class="{ 'is-new' : d.isNew }"
				 v-for="d in display" :key="d.id"
				 ref="project"
				 :style="{ backgroundImage: bgImage(d) }">

				<a :href="d.link" class="block"></a>
				<div class="project-mask"></div>
				<div class="project-d">
					<div class="project-d-view">
						<a :href="d.link" class="button port w-button">View project</a>
						<h3>{{ d.post_title }}</h3>
					</div>
					<p v-html="d.acf.excerpt"></p>
				</div>
			</div>

			<div class="loader" :class="{ loading: loading }"></div>

		</div>

		<div class="page-action" v-if="isMore && !sample">
			<a class="button mod-load-more active" @click.prevent="loadMore()" href="#">Load more</a>
		</div>

		<div class="page-action" v-else-if="sample">
			<a class="button w-button" href="/portfolio">See our full portfolio</a>
		</div>

	</div>

</template>


<script type="text/babel">

import Modal from './modal.vue';
import {uniqBy} from 'lodash';
import $ from 'jquery';
import Anime from "animejs";

export default {
	data() {
		return {
			catID: 1,
			start: 0,
			end: this.count,
			loading: false,
			modal: {
				src: '',
				open: false
			},
			projectsAni: null
		}
	},

	props: {
		posts: {type: Array, default: []},
		featured: {type: Array, default: []},
		count: {type: Number, default: 20},
		sample: {type: Boolean, default: false}
	},

	components: {
		'modal': Modal
	},

	mounted() {
		let vm = this;

		vm.setActive(vm.catID);

		let cParam = vm.getQueryStringValue("cat");
		if (cParam) {
			vm.setActive(parseInt(cParam))
		}
	},

	created() {
		Event.listen('close-modal', this.closeModal);
	},

	methods: {
        bgImage(d){
            if(d.acf && d.acf.video_still && d.acf.video_still.sizes){
                return 'url(' + d.acf.video_still.sizes.medium_large + ')';
            }
        },
		setActive(id) {
			this.loading = true;
			setTimeout(() => {
				this.end = this.count;
				this.catID = id;
			}, 400);
			setTimeout(() => {
				this.calcViewHeights();
			}, 401);
			setTimeout(() => {
				this.loading = false;
				this.playAnimation();
			}, 600);
		},

		loadMore() {
			let vm = this;
			vm.end += vm.count

			for (let i = vm.end - vm.count; i < vm.end; i++) {
				vm.display[i].isNew = true
			}

			setTimeout(() => {
				vm.calcViewHeights()
			}, 100)

			setTimeout(() => {

				var newProjectsAni = Anime({
					targets: '.ani-projects-custom-all.is-new',
					opacity: [0, 1],
					scale: [0.75, 1],
					duration: 1500,
					easing: 'easeOutExpo',
					autoplay: true,
					delay: Anime.stagger(200, {grid: [vm.display.length, 3], from: 'first'}),
				});

			}, 600);

			setTimeout(() => {
				vm.clearNew();
			}, 1000)
		},

		clearNew() {
			this.$refs.project.forEach(function (a) {
				a.classList.remove('is-new')
			})
		},

		openModal(src) {
			this.modal.src = src;
			this.modal.open = true;
			document.body.classList.add('modal-open', 'past-header');
		},

		closeModal() {
			this.modal.id = null;
			this.modal.open = false;
			document.body.classList.remove('modal-open', 'past-header');
		},

		calcViewHeights() {
			$('.project-d').each(function (i, v) {
				let view = $(v).find('.project-d-view').height()
				let y = $(v).height() - view;
				$(v).css('transform', 'translateY(' + y.toString() + 'px)')
			})
		},

		playAnimation() {
			let vm = this;

			vm.projectsAni = Anime({
				targets: '.ani-projects-custom-all',
				opacity: [0, 1],
				scale: [0.75, 1],
				duration: 1500,
				easing: 'easeOutExpo',
				autoplay: false,
				delay: Anime.stagger(200, {grid: [vm.display.length, 3], from: 'first'}),
			});

			vm.projectsAni.play()
		},

		getQueryStringValue(key) {
			return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
		}
	},

    computed: {
        store() {
            let store = [];

            for (let post of this.posts) {
                for (let cat of post.categories) {
                    if (cat.cat_ID === this.catID) {
                        store.push(post);
                        break;
                    }
                }
            }

            let data = store;

            if(this.featured && this.featured.length > 0) {
                this.featured.forEach(id => {
                    data.sort((a, b) => (b.ID === id && 1) || (a.ID === id && -1) || 0)
                });
            }

            return data;
        },

        categories() {
            let c = [];

            for (let post of this.posts) {
                for (let cat of post.categories) {
                    c.push(cat)
                }
            }

            return uniqBy(c, 'cat_ID');
        },

        display() {
            return this.store.slice(this.start, this.end);
        },

        isMore() {
            if ((this.count > 1) && (this.store.length > this.display.length)) {
                return true
            }
        }
    },


}

</script>
